<template>
 <div>
    <CRUDCriteria
      :showReset="true"
      :showSearch="false"
    >
      <template v-slot:criteriaRows>
        <v-row>
          <v-col cols="3">
            <FySelect
              id="bank-recon-criteria-FY-select"
              class="bankReconCriteriaFYSelect"
              :fyRange="fiscalYearRange"
              v-model="criteriaState.fiscalYear"
              @input="onChangeFy"
            />
          </v-col>
          <v-col cols="3">
            <ClarionDateControl
              v-model="criteriaState.asOfDate"
              :isRequired="false"
              :isToggle="false"
              :isIsoDate="true"
              :label="`As of Date`"
              @blurred="searchByCriteria"
            />
          </v-col>
          <v-col cols="3">
            <v-btn color="primary"
              rounded
              @click="checkDate"
              :disabled="checkStringEmptiness(criteriaState.asOfDate)"
            >
              Gather Information
            </v-btn>
            <GatherInfoConfimationDialog
              :dialog="dialog"
              :criteria="criteriaState"
              @dialogVal="setDialog"
              @loadCRUDList="handleLoadCRUDList"
            />
          </v-col>
           <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            rounded
            id="saBankReconciliationReportBtn"
            class="sai-bankReconciliationReport mt-4"
            depressed
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="openBankReconReport"
            :disabled="checkStringEmptiness(criteriaState.asOfDate)"
          >
          <v-icon left>
            {{ icons.mdiPrinter }}
          </v-icon>
            Print Reconciliation
          </v-btn>
          </template>
            <span>Print Reconciliation</span>
        </v-tooltip>
        </v-row>
      </template>
    </CRUDCriteria>
  </div>
</template>
<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import {
  mdiPrinter,
  mdiLockOutline,
  mdiLockOpenVariantOutline,
} from '@mdi/js';
import { calculateFiscalYears } from '../../../util/shared/tmc-global';
import CRUDCriteria from '../../common/base/crud/CRUDCriteria.vue';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import FySelect from '../../common/FySelect.vue';
import GatherInfoConfimationDialog from './GatherInfoConfimationDialog.vue';
import { checkStringEmptiness } from '../../../util/shared/vue-global';
import { clients } from '../../../util/clients';
import { queryStringCalcForReconReports } from '../Sai/report.util';
import { getRawJwt } from '../../../util/jwt';

const { backendRest } = clients.direct;

export default {
  name: 'TransactionCriteria',
  components: {
    CRUDCriteria,
    ClarionDateControl,
    FySelect,
    GatherInfoConfimationDialog,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'transactionCriteria',
    },
  },
  data: () => ({
    dialog: false,
    icons: {
      mdiPrinter,
      mdiLockOutline,
      mdiLockOpenVariantOutline,
    },
  }),
  created() {
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'item', 'items']),
    ...mapState({
      fiscalYearRange: (state) => {
        const registerdYears = state.glDaily.glDailyTransaction.regYears || {};
        return calculateFiscalYears(registerdYears);
      },
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    queryStringForSaiReconciliation: {
      cache: false,
      get() {
        return queryStringCalcForReconReports({
          criteria: this.criteriaState,
          singleBank: null,
          token: this.getAuthToken,
        });
      },
    },
    getAuthToken() {
      return getRawJwt();
    },
  },
  methods: {
    checkStringEmptiness,
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapActions('glDaily/saiBankReconciliation', [
      'saiBankReconGatherInformation',
    ]),
    searchByCriteria() {
      this.handleLoadCRUDList();
    },
    handleLoadCRUDList() {
      this.$emit('loadCRUDList');
    },
    onChangeFy() {
      this.searchByCriteria();
    },
    openBankReconReport() {
      const toUrl = `${backendRest.defaults.baseURL}/gl/sai/transactions/printSaiBankReconciliation${this.queryStringForSaiReconciliation}`;
      window.open(toUrl);
    },
    async gatherInfo() {
      const { fiscalYear, asOfDate } = this.criteriaState;
      const criteria = {
        asOfDate,
        fiscalYear,
        checkSaiMonthly: true,
      };
      await this.saiBankReconGatherInformation({ criteria });
      this.handleLoadCRUDList();
    },
    openDialogbox() {
      this.dialog = true;
    },
    setDialog(val) {
      this.dialog = val;
    },
    checkDate() {
      const criteriaDate = new Date(this.criteriaState.asOfDate).getDate();
      if (criteriaDate >= 25) {
        this.openDialogbox();
      } else {
        this.gatherInfo();
      }
    },
  },
};
</script>
